import styled from 'styled-components/macro'

export const StyledFiltersContainer = styled.div`
  height: auto;
  gap: 12px;
  position: absolute;
  right: ${({ isOpenRightModal }) => (isOpenRightModal ? '470px' : '14px')};
  top: 40px;
  transition: ${({ isOpenRightModal, posts }) => (() => {
    if (isOpenRightModal) {
      return posts.length
        ? 'right 0.6s ease-in-out'
        : 'right 0.6s cubic-bezier(0.34, 1.45, 0.64, 1)'
    }
    return 'right 0.7s ease-in-out'
  })()};
  z-index: 1404;
  overflow-y: scroll;
  scrollbar-width: none;
  ::-ms-overflow-style: none;
  ::-webkit-scrollbar {
    display: none;
  }

  // @media (max-width: 720px) {
  //   top: 40px;
  // }
`
